<template>
  <div class="xiaomi">
    <Breadcrumb
      :items="breadcrumb"
      class="xiaomi__breadcrumb"
    />
    <XiaomiStage @go-to-section="goToSection($event)" />

    <CouponCheck
      teaser-copy="Xiaomi-Gutscheine und Coupons direkt hier einlösen und aktuelle Preisvorteile sichern."
      mini-version
      tag-title="h3"
      medium
      :coupon-brands="['xiaomi']"
      class="xiaomi__coupon-section"
      custom-brand-error="Der eingegebene Code ist nicht für Produkte von Xiaomi gültig."
    />

    <ScooterSection
      ref="scooterLite4"
      :offers="getOffersByGroup(offers, 'scooterCompare', 3)"
      class="xiaomi__section"
    />
    <MiHomeApp class="xiaomi__section" />
    <XiaomiWatchConfiguratorWrapper
      ref="watchPro"
      class="xiaomi__section"
    />
    <XiaomiBuds
      ref="redmiBuds5"
      class="xiaomi__section"
      :buds="getOffersByGroup(offers, 'buds')"
    />
    <XiaomiLifestyle
      ref="airFryer"
      class="xiaomi__section"
      :items="getOffersByGroup(offers, 'lifestyle')"
    />
    <XiaomiTeasers class="xiaomi__section" />
  </div>
</template>

<script lang="ts">
import { useLazyAsyncData } from '#imports';
import { defineComponent, ref } from 'vue';
import {
  getOffersByGroup,
  loadOffersForPromotions,
  type Promotion,
  type PromotionOffer,
} from '@/lib/offers-by-group';
import XiaomiStage from '@/components/xiaomi/xiaomi-stage.vue';
import ScooterSection from '@/components/xiaomi/scooter-section.vue';
import MiHomeApp from '@/components/xiaomi/mi-home-app.vue';
import XiaomiBuds from '@/components/xiaomi/xiaomi-buds.vue';
import XiaomiTeasers from '@/components/xiaomi/xiaomi-teasers.vue';

import Breadcrumb from '@/components/breadcrumb.vue';
import CouponCheck from '@/components/treueshop/coupon-check.vue';
import XiaomiWatchConfiguratorWrapper from '@/components/xiaomi/xiaomi-watch-configurator-wrapper.vue';
import { Track } from '@/helpers/page-tracking';
import { getHeader } from '@/helpers/page-header-compositon';
import XiaomiLifestyle from '@/components/xiaomi/xiaomi-lifestyle.vue';

type XiaomiPromotion = Promotion<any>;

const PRODUCT_TEASER_DATA: XiaomiPromotion = [
  {
    articleNumber: '6941812765388',
    tileGroups: ['scooterCompare'],
  },
  {
    articleNumber: '6941812765791',
    tileGroups: ['scooterCompare'],
  },
  {
    articleNumber: '',
    tileGroups: ['scooterCompare'],
  },
  {
    articleNumber: '6941812746110',
    tileGroups: ['buds'],
    label: 'Redmi Buds 5 Pro',
    images: {
      initial: {
        background:
          '/content/content-images/landingpages/xiaomi/buds/a4f2a250878717fa85c38240eb3d78de/redmi-buds-5pro-bg@2x.jpg',
        visual:
          '/content/content-images/landingpages/xiaomi/buds/1391b508305fc1f685af88a4e9d3c7db/redmi-buds-5pro@2x.png',
        alt: 'Redmi Buds 5 Pro',
      },
      hover: {
        src: '/content/content-images/landingpages/xiaomi/buds/b782d108b27246813b2b694b5a6ef39c/redmi-buds-5pro-bg-hover@2x.jpg',
        alt: 'Frau trägt Redmi Buds 5 Pro',
      },
    },
  },
  {
    articleNumber: '6941812744338',
    tileGroups: ['buds'],
    label: 'Redmi Buds 5',
    images: {
      initial: {
        background:
          '/content/content-images/landingpages/xiaomi/buds/c5fbe7dac59a2112b40c1a3fc82cb0e9/redmi-buds-5-bg@2x.jpg',
        visual:
          '/content/content-images/landingpages/xiaomi/buds/84e624aab26adbe1ac13861dde1906ef/redmi-buds-5@2x.png',
        alt: 'Redmi Buds 5',
      },
      hover: {
        src: '/content/content-images/landingpages/xiaomi/buds/91a527ccd24b7c3cbc03917359e415b6/redmi-buds-5-bg-hover@2x.jpg',
        alt: 'Mann trägt Redmi Buds 5',
      },
    },
  },
  {
    articleNumber: '6941812721032',
    tileGroups: ['buds'],
    label: 'Redmi Buds 4 Lite',
    images: {
      initial: {
        background:
          '/content/content-images/landingpages/xiaomi/buds/96f8ff4d42c7890eec2aaba0a0a8d806/redmi-buds-4-lite-bg@2x.jpg',
        visual:
          '/content/content-images/landingpages/xiaomi/buds/d50e249e3fa224ece185c5f8783d0368/redmi-buds-4-lite@2x.png',
        alt: 'Redmi Buds 4 Lite',
      },
      hover: {
        src: '/content/content-images/landingpages/xiaomi/buds/24e9d5a07d28e4ad6733bb3e2d2587bf/redmi-buds-4-lite-bg-hover@2x.jpg',
        alt: 'Frau trägt Redmi Buds 4 Lite',
      },
    },
  },
  {
    articleNumber: '6941812712733',
    tileGroups: ['buds'],
    label: 'Redmi Buds 4 Active',
    images: {
      initial: {
        background:
          '/content/content-images/landingpages/xiaomi/buds/5278b8ff4714d97b4f654a893c22f679/redmi-buds-4-active-bg@2x.jpg',
        visual:
          '/content/content-images/landingpages/xiaomi/buds/62590498743adfb6ada7233f4ae77430/redmi-buds-4-active@2x.png',
        alt: 'Redmi Buds 4 Active',
      },
      hover: {
        src: '/content/content-images/landingpages/xiaomi/buds/a08095fe7ef1a8585ad2de06dae87f83/redmi-buds-4-active-bg-hover@2x.jpg',
        alt: 'Frau trägt Redmi Buds 4 Active',
      },
    },
  },
  {
    lazy: true,
    articleNumber: '6941812729311',
    tileGroups: ['lifestyle'],
    card: {
      customStyles: '--card-bg-color: #DDDDDB',
      background: {
        src: '/content/content-images/landingpages/xiaomi/lifestyle/1c754667b52d1a9ab43a05e047e9a9c7/xiaomi-air-fryer-s@2x.jpg',
        srcMd:
          '/content/content-images/landingpages/xiaomi/lifestyle/ad9df48f6fb450978e53b16d8d7031d1/xiaomi-air-fryer-l@2x.jpg',
        lazy: true,
      },
      heading: {
        text: 'Xiaomi Smart Air Fryer 6.5l',
        tag: 'h2',
        size: 'md',
      },
    },
    typeComponent: 'long',
  },
  {
    articleNumber: '6941812708293',
    tileGroups: ['lifestyle'],
    card: {
      customStyles: '--card-bg-color: #DDDDDB',
      background: {
        src: '/content/content-images/landingpages/xiaomi/lifestyle/7c0b3a063fcde2cd490129fcfc0e7c58/xiaomi-air-fryer-pro-4-s@2x.jpg',
        srcMd:
          '/content/content-images/landingpages/xiaomi/lifestyle/1fed9bc50b5cf3032c92abdca8827693/xiaomi-air-fryer-pro-4-l@2x.jpg',
        lazy: true,
      },
      heading: {
        text: 'Xiaomi Smart Air Fryer Pro 4L',
        tag: 'h2',
        size: 'md',
      },
    },
    typeComponent: 'short',
    customClass: 'double-height',
  },
  {
    lazy: true,
    articleNumber: '6971408157327',
    tileGroups: ['lifestyle'],
    card: {
      customStyles: '--card-bg-color: #DDDDDB',
      background: {
        src: '/content/content-images/landingpages/xiaomi/lifestyle/a0c2358833cb605058abc3fbb4d9ff6b/xiaomi-tv-a2-s@2x.jpg',
        srcMd:
          '/content/content-images/landingpages/xiaomi/lifestyle/0a1d7549d3d945efa1b0c98bb369c472/xiaomi-tv-a2-l@2x.jpg',
        lazy: true,
      },
      heading: {
        text: 'Xiaomi TV A2',
        tag: 'h2',
        size: 'md',
      },
    },
    typeComponent: 'long',
  },
  {
    lazy: true,
    articleNumber: '6941812728178',
    tileGroups: ['lifestyle'],
    card: {
      customStyles: '--card-bg-color: #DDDDDB',
      background: {
        src: '/content/content-images/landingpages/xiaomi/lifestyle/2fdc9c5c3ea0e972703891c3c1493dc3/xiaomi-robot-vaccuum-s12-s@2x.jpg',
        srcMd:
          '/content/content-images/landingpages/xiaomi/lifestyle/c29229e9227fefe747bf6f799144cc3a/xiaomi-robot.vaccum-s12-l@2x.jpg',
        lazy: true,
      },
      heading: {
        text: 'Xiaomi Robot Vacuum S12',
        tag: 'h2',
        size: 'md',
      },
    },
    typeComponent: 'short',
  },
  {
    lazy: true,
    articleNumber: '6934177794025',
    tileGroups: ['lifestyle'],
    card: {
      customStyles: '--card-bg-color: #DDDDDB;',
      background: {
        src: '/content/content-images/landingpages/xiaomi/lifestyle/3d8492e928fd5244d4f0927f5f010d70/xiaomi-robot-vaccuum-s10+-s@2x.jpg',
        srcMd:
          '/content/content-images/landingpages/xiaomi/lifestyle/6bf70a99f6612c97737234cdad58eccf/xiaomi-robot-vaccuum-s10+-l@2x.jpg',
        lazy: true,
      },
      heading: {
        text: 'Xiaomi Robot Vacuum S10+',
        tag: 'h2',
        size: 'md',
      },
    },
    typeComponent: 'long',
  },
];

export default defineComponent({
  components: {
    XiaomiLifestyle,
    XiaomiWatchConfiguratorWrapper,
    Breadcrumb,
    CouponCheck,
    XiaomiStage,
    ScooterSection,
    MiHomeApp,
    XiaomiBuds,
    XiaomiTeasers,
  },
  head: {},
  methods: {
    goToSection(refString: string) {
      this.$nextTick(() => {
        if (this.$refs[refString]?.$el) {
          this.$refs[refString].$el.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
          this.$refs[refString].focus();
        }
      });
    },
  },
  setup: () => {
    Track({ page_type: 'theme.landing' });

    getHeader({
      title: ref('Xiaomi Produkte entdecken'),
      description: ref(
        'Entdecke unsere Themenwelt von Xiaomi: Hier findest Du alles aus den Bereichen Smartphones & Zubehör. Vom Fotodrucker bis hin zu Monitor ist alles dabei!'
      ),
    });

    const breadcrumb = [
      {
        label: 'Xiaomi',
        to: 'xiaomi',
      },
    ];

    const { data: offers, error: errorData } = useLazyAsyncData(
      'xiaomi-offers',
      (): Promise<PromotionOffer<XiaomiPromotion>> =>
        loadOffersForPromotions(PRODUCT_TEASER_DATA, false, false)
    );

    // handle errors
    if (errorData.value) {
      console.error(errorData.value);
    }

    return { breadcrumb, getOffersByGroup, offers };
  },
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.xiaomi {
  &__coupon-section {
    background: linear-gradient(180deg, #ffffff 0%, #f8f8f8 100%);
    @include mq($mq-md) {
      padding-top: 3 * $grid-base;
    }

    :deep(.coupon-teaser__hero-image) {
      max-width: 206px;
    }
  }

  @include mq($mq-sm) {
    margin: 0;
  }

  @include mq($mq-md) {
    max-height: none;
  }

  &__section {
    padding-block: 40px;

    @include mq($mq-md) {
      padding-block: 60px;
    }
  }
}
</style>
